import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineLeaseType";

const url = "/api/machines/MachineLeaseType";

export const machineLeaseTypeLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Lease Type",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
